// extracted by mini-css-extract-plugin
export default {"container":"style_container__b6IHB","title":"style_title__UzxXW","description":"style_description__PzSuP"};